var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 0.00162652C14.6353 -0.00484713 7.07252 7.57064 7.05861 16.9438C7.05218 21.1936 8.78712 24.824 11.4021 27.9198C16.1709 33.5656 20.3433 39.5106 22.6213 46.646C22.8271 47.2902 23.1334 48.0218 24.0136 47.9995C24.9713 47.9752 25.2287 47.1553 25.456 46.4613C27.5938 39.9324 31.1653 34.2917 35.6786 29.1694C38.3614 26.1244 40.5128 22.6158 40.8738 18.4946C41.7539 8.45106 33.8648 -0.135773 23.9974 0.00162652Z",
    fill: "url(#paint0_linear_714_299)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9065 16.6041C19.0828 16.2323 18.4033 15.9302 18.4033 15.3144C18.4033 14.8496 18.7881 14.5068 19.5517 14.5068C19.8343 14.5068 20.0628 14.5417 20.2973 14.5824C20.4236 14.6056 20.5559 14.623 20.6641 14.623C21.3315 14.623 21.7103 14.2396 21.9568 13.5076L22.059 13.2113C21.9508 13.1706 20.8625 12.7058 19.4375 12.7058C17.1768 12.7058 15.9802 14.106 15.9802 15.5642C15.9802 16.2962 16.2147 16.8307 16.5875 17.249C17.0685 17.7893 17.754 18.1379 18.3913 18.44C19.3233 18.8816 20.165 19.2069 20.165 19.8634C20.165 20.4444 19.5457 20.7755 18.716 20.7755C17.5796 20.7755 16.5815 20.1481 16.4552 20.0725L15.5293 21.7574C15.6977 21.8503 16.9002 22.5882 18.8783 22.5882C20.9888 22.5882 22.5881 21.4204 22.5881 19.6194C22.5881 17.83 21.109 17.1619 19.9065 16.6041Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3491 17.3721L32.2676 12.7058H29.4748L26.3499 16.7328H26.3007V12.7058H24V22.5882H24.1353C25.1257 22.5882 26.313 22.1401 26.313 20.5269V18.2564H26.356L29.5425 22.4627H32.4706L28.3491 17.3721Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_714_299",
    x1: 23.9998,
    y1: 0,
    x2: 23.9998,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46A29"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.db016e57d9de9079673697295292617d.svg";
export { ForwardRef as ReactComponent };